import { gql } from '@apollo/client'

export const GET_LOGGED_IN_USER_KYC_STATUS = gql`
  query LoggedInUserKycStatus {
    loggedInUser {
      id
      knowYourCustomer {
        status
      }
    }
  }
`
